import React, { FC } from 'react';
import { SelfScanSteps } from './SelfScanSteps/SelfScanSteps';

export const SelfScanStepsPage: FC = () => {
  return <SelfScanSteps />;
};
